var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 24,
    viewBox: "0 0 15 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.26154 11.4C6.57372 11.4 5.91408 11.0839 5.42772 10.5213C4.94137 9.95871 4.66813 9.19565 4.66813 8.4C4.66813 7.60435 4.94137 6.84129 5.42772 6.27868C5.91408 5.71607 6.57372 5.4 7.26154 5.4C7.94935 5.4 8.609 5.71607 9.09535 6.27868C9.58171 6.84129 9.85495 7.60435 9.85495 8.4C9.85495 8.79397 9.78787 9.18407 9.65753 9.54805C9.5272 9.91203 9.33617 10.2427 9.09535 10.5213C8.85453 10.7999 8.56864 11.0209 8.25399 11.1716C7.93935 11.3224 7.60211 11.4 7.26154 11.4ZM7.26154 0C5.33566 0 3.48866 0.884998 2.12686 2.4603C0.765053 4.03561 0 6.17218 0 8.4C0 14.7 7.26154 24 7.26154 24C7.26154 24 14.5231 14.7 14.5231 8.4C14.5231 6.17218 13.758 4.03561 12.3962 2.4603C11.0344 0.884998 9.18742 0 7.26154 0Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.7ce4820e166f3ce5df3e630bb6fb0454.svg";
export { ForwardRef as ReactComponent };